module.exports = {
      id: "crash300 index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#crash300 index-usage",
      toString: function () {
        return this.url;
      }
    }